import { ISlot } from '../../organisms/bo_calendar_slot/types';
import { useCalendarStoreSelector } from './useCalendarStoreSelector';

type Props = {
	resourceId: number;
};

type UseResourceSlotsByDateResult = {
	slotsByDate: Map<string, ISlot[]>;
};

/**
 * Custom hook to retrieve resource slots grouped by date.
 * @param resourceId {number} - The ID of the resource to fetch slots for.
 * @return {UseResourceSlotsByDateResult} - An object containing slots grouped by date and a function to update slot data.
 */
export const useResourceSlotsByDate = ({ resourceId }: Props): UseResourceSlotsByDateResult => {
	const getResourceSlotsByDate = useCalendarStoreSelector(state => state.getResourceSlotsByDate);

	return {
		slotsByDate: getResourceSlotsByDate(resourceId),
	};
};
